import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  employeeEffortsCalculation: null,
  associateInstallation: null,
    assoInstaPiechart: null, // 👈 Add pie chart state
    installationPLChart : null,
};

const salesFinanceSlice = createSlice({
  name: 'salesFinance',
  initialState,
  reducers: {
       setEmployeeEffortsCalculation: (state, action) => {
      state.employeeEffortsCalculation = action.payload;
    },
    setAssociateInstallation: (state, action) => {
      state.associateInstallation = action.payload;
    },
      setAssoInstaPiechart: (state, action) => {
      state.assoInstaPiechart = action.payload;
    },
      setInstallationPLPiechart: (state, action) => {
      state.installationPLChart = action.payload;
    },
    resetSalesFinanceState: (state) => {
      state.associateInstallation = null;
            state.assoInstaPiechart = null; // 👈 Reset this too
    },
  },
});

export const {
  setEmployeeEffortsCalculation,
  setAssociateInstallation,
  setAssoInstaPiechart,
  resetSalesFinanceState,
  setInstallationPLPiechart,
} = salesFinanceSlice.actions;

export default salesFinanceSlice.reducer;
